import './lib/blazor-window-bindings';

console.log('Welcome to Moobob.')